module.exports = __webpack_public_path__ + "static/media/Visa.b41b9b06.svg";